import React, { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { usePAChecklistFollowUp } from '../pa_checklist_followup_context';
import styles from '../pa_checklist_followup.module.scss'
import ChecklistFupInfoTab from './pa_checklist_fup_info_tab';
import ChecklistFupRevTab from './pa_checklist_fup_revisao_tab';
import ChecklistFupDirTab from './pa_checklist_fup_analise_tab';
import ChecklistFupMedTab from './pa_checklist_fup_medidas_tab';
import ChecklistFupProvaTab from './pa_checklist_fup_prova_roupa_tab';
import ChecklistFupFinalTab from './pa_checklist_fup_finalizacao_tab';
import { api } from '../../../../services/api';
import { useMisc } from '../../../../contexts/MiscContext';

const PAChecklistFollowUpModal = () => {
  const { setShowLoading } = useMisc();
  const { tab, setTab, itemSelecionado, modalFup, fecharModalFup, processarFinalizacaoChecklist, isAdmin, usuarioAdminFup } = usePAChecklistFollowUp();
  const tabColor = (x) => {
    return tab === x ? { backgroundColor: '#FFF', borderBottom: 'none' } : { backgroundColor: '#F5F5F5' };
  }

  return (
    <>
      <Modal
        show={modalFup}
        centered
        fullscreen={true}
      >
        <Modal.Header style={{fontWeight: '500'}}>
          Follow-Up {itemSelecionado.nf_segunda_qualidade ? '(Segunda Qualidade)' : ''} | NF: {itemSelecionado.nf_entrada} | Produto: {itemSelecionado.produto} | Cor: {itemSelecionado.cor_produto} | Romaneio Entrada: {itemSelecionado.romaneio_entrada} | Romaneio Saída: {itemSelecionado.romaneio_nf_saida}

          <Button
            variant={'secondary'}
            className={styles.footer_btn_processamento}
            onClick={() => fecharModalFup()}
          >
            Voltar
          </Button>
        </Modal.Header>
        <Modal.Body>
          <section className={styles.tab_wrapper}>
            <div className={styles.tab} style={tabColor(0)} onClick={() => setTab(0)}>Informações</div>
            <div className={styles.tab} style={tabColor(1)} onClick={() => setTab(1)}>Revisão</div>
            <div className={styles.tab} style={tabColor(2)} onClick={() => setTab(2)}>Análise</div>
            <div className={styles.tab} style={tabColor(3)} onClick={() => setTab(3)}>Medidas</div>
            <div className={styles.tab} style={tabColor(4)} onClick={() => setTab(4)}>Prova de Roupa</div>
            <div className={styles.tab} style={tabColor(5)} onClick={() => setTab(5)}>Resultado Final</div>
          </section>
          <section className={styles.outer_tab_wrapper}>
            {tab === 0 && <ChecklistFupInfoTab />}
            {tab === 1 && <ChecklistFupRevTab />}
            {tab === 2 && <ChecklistFupDirTab />}
            {tab === 3 && <ChecklistFupMedTab />}
            {tab === 4 && <ChecklistFupProvaTab />}
            {tab === 5 && <ChecklistFupFinalTab />}
          </section>
        </Modal.Body>
        <Modal.Footer>
          {
            tab === 5 && !itemSelecionado.finalizacao_ok &&
            <Button
              variant={'success'}
              className={styles.footer_btn_processamento}
              onClick={() => processarFinalizacaoChecklist()}
              style={{ marginTop: '10px' }}
              disabled={
                (!isAdmin && !usuarioAdminFup) ||
                (
                  !itemSelecionado.conferencia_caixa_ok ||
                  !itemSelecionado.analise_ok ||
                  !itemSelecionado.prova_de_roupa_ok ||
                  !itemSelecionado.revisao_ok
                )
              }
            >
              Processar Finalização
            </Button>
          }

          {/* Chama um endpoint que tenta aprovar automaticamente a referência */}
          {/* Caso isso não tenha ocorrido automaticamente e o status final sugerido seja aprovado */}
          {/* Para uso apenas em casos isolados por desenvolvedores */}
          {/* <Button
            variant={'danger'}
            className={styles.footer_btn_processamento}
            onClick={async () => {
              try {
                setShowLoading(true);
                const params = { id_entrada_fiscal: itemSelecionado.id_entrada_fiscal }
                await api.post('pa/checklist-fup/checklist-processamento-automatico', params);
              } catch (e) {
                console.error(e);
              } finally {
                setShowLoading(false);
              }
            }}
            style={{ marginTop: '10px' }}
          >
            Tentar Finalização Automática
          </Button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default PAChecklistFollowUpModal;
